import { createReducer } from '@reduxjs/toolkit';
import { apiRequestSuccess } from 'services/api/api.actions';
import { getBarcodeCodeEndpoint } from './barcode.config';
import { Barcode } from './barcode.types';

const initialValues = {} as Barcode;

const barcodeReducer = createReducer(initialValues, (builder) =>
  builder.addCase(apiRequestSuccess, (state, action) => {
    const { payload } = action;

    if (payload.resourceId === getBarcodeCodeEndpoint) {
      const barcode = payload.response?.data?.barcode as Barcode;
      Object.assign(state, barcode);
      return;
    }
  }),
);

export default barcodeReducer;
